import type { BillingInterval } from '@weft/types';
import type { FixedProductPriceEstimator } from '..';
import { getBillingIntervalInMonths } from '../../../../billing-settings-number-converter';
import type { SubscriptionProduct } from '../../../../products-filter/products-filter-types/pricing-product';

const MONTHS_IN_YEAR = 12;

export class SubscriptionPriceEstimator implements FixedProductPriceEstimator<SubscriptionProduct, BillingInterval> {
  estimate(product: SubscriptionProduct, billingPeriod: BillingInterval): number {
    const price = product.variants[0].pricing.priceConfiguration.price;

    return this.calculateSubscriptionPrice(price, billingPeriod);
  }

  private calculateSubscriptionPrice(fixedPrice: number, billingPeriod: BillingInterval) {
    const billingPeriodInMonths = getBillingIntervalInMonths(billingPeriod);

    // Since subscription is acting as monthly charge, we need to multiply it by billingIntervalInMonths again
    return fixedPrice * billingPeriodInMonths * (MONTHS_IN_YEAR / billingPeriodInMonths);
  }
}